import { axios } from '@/utils/request'

/**
 * 查询处方药品发药退药记录表
 *
 * @author zhangjw
 * @date 2023-09-14 17:41:03
 */
export function baRecipeDrugRecordPage (parameter) {
  return axios({
    url: '/baRecipeDrugRecord/page',
    method: 'get',
    params: parameter
  })
}

/**
 * 处方药品发药退药记录表列表
 *
 * @author zhangjw
 * @date 2023-09-14 17:41:03
 */
export function baRecipeDrugRecordList (parameter) {
  return axios({
    url: '/baRecipeDrugRecord/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 添加处方药品发药退药记录表
 *
 * @author zhangjw
 * @date 2023-09-14 17:41:03
 */
export function baRecipeDrugRecordAdd (parameter) {
  return axios({
    url: '/baRecipeDrugRecord/add',
    method: 'post',
    data: parameter
  })
}

/**
 * 编辑处方药品发药退药记录表
 *
 * @author zhangjw
 * @date 2023-09-14 17:41:03
 */
export function baRecipeDrugRecordEdit (parameter) {
  return axios({
    url: '/baRecipeDrugRecord/edit',
    method: 'post',
    data: parameter
  })
}

/**
 * 删除处方药品发药退药记录表
 *
 * @author zhangjw
 * @date 2023-09-14 17:41:03
 */
export function baRecipeDrugRecordDelete (parameter) {
  return axios({
    url: '/baRecipeDrugRecord/delete',
    method: 'post',
    data: parameter
  })
}

/**
 * 导出处方药品发药退药记录表
 *
 * @author zhangjw
 * @date 2023-09-14 17:41:03
 */
export function baRecipeDrugRecordExport (parameter) {
  return axios({
    url: '/baRecipeDrugRecord/export',
    method: 'get',
    params: parameter,
    responseType: 'blob'
  })
}
